import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "app" };
const _hoisted_2 = { class: "header-content" };
const _hoisted_3 = { class: "header-actions" };
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Picture, Headset, VideoCamera, Search } from '@element-plus/icons-vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const activeIndex = computed(() => route.path);
        const refresh = () => {
            window.location.reload();
        };
        const handleMenuSelect = (index) => {
            console.log('[Menu] Selected:', index);
            router.push(index);
        };
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_header = _resolveComponent("el-header");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_menu_item = _resolveComponent("el-menu-item");
            const _component_el_menu = _resolveComponent("el-menu");
            const _component_el_scrollbar = _resolveComponent("el-scrollbar");
            const _component_el_aside = _resolveComponent("el-aside");
            const _component_router_view = _resolveComponent("router-view");
            const _component_el_main = _resolveComponent("el-main");
            const _component_el_container = _resolveComponent("el-container");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_container, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_header, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Ai档案管理（设计行业）", -1)),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(_component_el_button, {
                                            type: "primary",
                                            onClick: refresh
                                        }, {
                                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                                    _createTextVNode("刷新", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_container, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_aside, { width: "200px" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_scrollbar, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_menu, {
                                                    "default-active": activeIndex.value,
                                                    mode: "vertical",
                                                    "background-color": "#545c64",
                                                    "text-color": "#fff",
                                                    "active-text-color": "#ffd04b",
                                                    onSelect: handleMenuSelect
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_menu_item, { index: "/photos" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_el_icon, null, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_unref(Picture))
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _cache[2] || (_cache[2] = _createElementVNode("span", null, "照片管理", -1))
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_el_menu_item, { index: "/audios" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_el_icon, null, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_unref(Headset))
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _cache[3] || (_cache[3] = _createElementVNode("span", null, "录音管理", -1))
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_el_menu_item, { index: "/videos" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_el_icon, null, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_unref(VideoCamera))
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _cache[4] || (_cache[4] = _createElementVNode("span", null, "录像管理", -1))
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_el_menu_item, { index: "/document" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_el_icon, null, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_unref(Search))
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _cache[5] || (_cache[5] = _createElementVNode("span", null, "企业知识管理", -1))
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }, 8, ["default-active"])
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_main, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_scrollbar, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_router_view)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
